import getTranslation from '@/locale/getTranslation'
export default [
  {
    path: '/mail',
    name: 'sendMail',
    component: resolve => require(['@/views/mail/Upload'], resolve),
    meta: {
      title: getTranslation('下载'),
      keepAlive: true
    }
  }
]
